
import { Injectable } from '@angular/core';
import { Ortak } from '../../providers/ortak';
import { Servis } from '../../providers/servis';


@Injectable()
export class BllOrtak {
  offmode:number=2;
  constructor(public servis: Servis, 
        public ortak: Ortak,
 
   ) {

  }


  islem(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.ortak.ServisUrl + method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
       
          err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
          //  this.ortak.showBasicAlert("","Sunucu ile bağlantı kurulamıyor lütfen ayarlarınızı kontrol edin");
         err(x);
      })

    })
  }
  etiketbas(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.ortak.ServisUrl + method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
       
          err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
          
         err(x);
      })

    })
  }
  yazdir(formData: FormData, method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makePostRequest(this.ortak.ServisUrl + method, formData).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
         
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
       
          err(sonuc.Exception);

        }
        else
          res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
        
         err(x);
      })

    })
  }
 
  islemWithoutPost(method: string, loadingContent: string, showLoading: boolean) {
    return new Promise((res, err) => {
      if (loadingContent == "")
        loadingContent = "Lütfen bekleyiniz.";
      var loading;
      if (showLoading)
        loading = this.ortak.showLoadingControl(loadingContent);
      this.servis.makeGetRequest(this.ortak.ServisUrl + method).then(a => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
        var sonuc = <any>a;
        if (sonuc.Sonuc == 99) {
         // this.ortak.showBasicAlert("Hata", sonuc.Exception);
        }
        res(sonuc);
      }).catch(x => {
        if (showLoading)
          this.ortak.hideLoadingControl(loading);
        err(x);
      })

    })
  }

  


}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-ortak.ts